import type { Tour } from '../../types';

export const welcomeTour: Tour = {
  id: 'institution-welcome',
  name: 'Welcome Tour',
  description: 'Get started with the OHCS Records Management System',
  category: 'institution',
  showProgress: true,
  steps: [
    {
      id: 'welcome-1',
      target: 'header-logo',
      title: 'Welcome to OHCS RMS',
      content: 'This is your central hub for managing documents, personnel files, and workflows within your institution. Let us show you around!',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'welcome-2',
      target: 'sidebar',
      title: 'Navigation Sidebar',
      content: 'Use the sidebar to navigate between different sections of the system. You can access Dashboard, Records, Tasks, Workflows, and more.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'welcome-3',
      target: 'sidebar-dashboard',
      title: 'Dashboard',
      content: 'Your dashboard provides an overview of recent activity, pending tasks, and key metrics at a glance.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'welcome-4',
      target: 'sidebar-records',
      title: 'Records Management',
      content: 'Access and manage all your documents here. Organize files into folders, track versions, and maintain a complete audit trail.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'welcome-5',
      target: 'sidebar-pfiles',
      title: 'Personnel Files',
      content: 'The PFile system uses a jacket-based approach to organize employee records. Each staff member has a personal file jacket containing their documents.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'welcome-6',
      target: 'header-notifications',
      title: 'Notifications',
      content: 'Stay updated with notifications about document approvals, task assignments, and important updates.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'welcome-7',
      target: 'header-help',
      title: 'Help & Support',
      content: 'Need help? Click here to access guides, tutorials, and keyboard shortcuts. You can also restart this tour anytime from the Help menu.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'welcome-8',
      target: 'header-user',
      title: 'Your Account',
      content: 'Access your profile settings, change password, and log out from here. Welcome aboard!',
      position: 'bottom',
      spotlight: true,
      actionLabel: 'Get Started',
    },
  ],
};
